var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
// --- Auth API ---
export const authApi = {
    getCsrfToken: () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get('/api/api-auth/csrf/');
        return res.data.csrfToken || res.data['csrfToken'] || res.data;
    }),
    getAuthToken: (username, password) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.post('/api/api-auth-token/', { username, password });
        return res.data;
    }),
    login: (username, password, csrfToken) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.post('/api/api-auth-dj-rest/login/', { username, password }, { headers: { 'X-CSRFToken': csrfToken } });
        return res.data;
    }),
    register: (data) => __awaiter(void 0, void 0, void 0, function* () {
        const payload = {
            username: data.username,
            email: data.email,
            password1: data.password1,
            password2: data.password2,
        };
        const res = yield axiosInstance.post('/api/api-auth-dj-rest/registration/', payload);
        return res.data;
    }),
    changePassword: (oldPassword, newPassword1, newPassword2) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post('/api/api-auth-dj-rest/password/change/', {
            oldPassword: oldPassword,
            newPassword1: newPassword1,
            newPassword2: newPassword2,
        }, config);
        return res.data;
    }),
    logout: () => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.post('/api/api-auth-dj-rest/logout/', {}, config);
    }),
};
// --- CSRF headers helper ---
export function getCsrfTokenFromCookie() {
    var _a;
    return (_a = document.cookie
        .split('; ')
        .find((row) => row.startsWith('csrftoken='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
}
export const getCsrfHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
    const localCsrfToken = getCsrfTokenFromCookie();
    if (localCsrfToken) {
        return { headers: { 'X-CSRFToken': localCsrfToken } };
    }
    // If no local CSRF token, fetch it from the API
    const csrfToken = yield authApi.getCsrfToken();
    return { headers: { 'X-CSRFToken': csrfToken } };
});
